module.exports = __webpack_public_path__ + "img/right-angle.85df9023.svg";